import React from "react";
import ExperienceContainer from "../components/experience/ExperienceContainer";
import { Container } from "../styles/global";

const Experience = () => {
  return (
    <Container className="experience-wrapper">
      <img src="assest/images/sectionHeaders/experience.png" alt="experince" />

      <div className="mt-10">
        <ExperienceContainer />
      </div>
    </Container>
  );
};

export default Experience;
